import _ from 'lodash';

const roles = {
  0: 'super',
  10: 'administrator',
  20: 'manager',
  30: 'analyst',
  40: 'responder',
  50: 'monitor',
};

const dashboards = {
  0: 'manager',
  10: 'manager',
  20: 'manager',
  30: 'analyst',
  40: 'responder',
  50: 'tv-mode',
};

class Settings {
  constructor(settings = {}) {
    this.settings = settings;
    this.fetched = false;
  }

  update(settings) {
    this.settings = settings;
    const userRoles = _.get(settings, 'user.roles', []);
    const orgRoles = {};
    _.each(userRoles, (r) => {
      r.role = roles[r.role_id];
      r.dashboard = dashboards[r.role_id];
      orgRoles[r.org_id] = r;
    });
    if (!this.settings.user) this.settings.user = {};
    this.settings.user.orgRoles = orgRoles;
    this.settings.roles = roles;
    return this;
  }

  get(key, defaultValue, tryLocalStorage = true) {
    if (tryLocalStorage) {
      try {
        let value = window.localStorage.getItem(key);
        if (!_.isUndefined(value) && value !== null) {
          try {
            value = JSON.parse(value);
          } catch (e) {
            // pass
          }
          if (_.isUndefined(value)) {
            return defaultValue;
          }
          return value;
        }
      } catch (e) {
        console.error(e);
        // pass
      }
    }
    return _.get(this.settings, key, defaultValue);
  }

  set(key, data, tryLocalStorage = false) {
    if (tryLocalStorage) {
      try {
        window.localStorage.setItem(key, data);
        return this;
      } catch (e) {
        console.error(e);
        // pass
      }
    }
    this.settings[key] = data;
    return this;
  }

  clear() {
    this.settings = {};
    this.fetched = false;
    return this;
  }

  toJSON() {
    return this.settings;
  }
}

export const settings = new Settings();

window.settings = settings; // @xxx



// WEBPACK FOOTER //
// ./src/lib/settings.js